import { LIVE_CLASSES_ROLES, NCMS_ROLES } from "utils/role-restriction/helper";
import Products from "./routes/products";
import Platform from "./routes/platforms";
import Projects from "./routes/projects";
import Vendors from "./routes/vendors";
import VendorAccounts from "./routes/vendor-accounts";
import VendorUsers from "./routes/vendor-users";
import VendorProjectUsers from "./routes/vendor-project-users";
import EmployeeDepartments from "./routes/employee-departments";
import EmployeeDesignations from "./routes/employee-designations";
import Teachers from "./routes/teachers";
import Nl3LiveclassPackages from "./routes/nl3-liveclass-packages";
import { CreateNl3LiveclassPackage } from "./routes/nl3-liveclass-packages/create";
import Nl3PackageSchedules from "./routes/nl3-package-schedules";
import { CreateNl3PackageSchedule } from "./routes/nl3-package-schedules/create";
import { EditNl3PackageSchedule } from "./routes/nl3-package-schedules/edit";
import LiveSessions from "./routes/nl3-package-schedules/schedule-buttons/live-sessions";
import AllocatedSession from "./routes/nl3-package-schedules/schedule-buttons/allocated-session";
import AttendanceSummary from "./routes/nl3-package-schedules/schedule-buttons/attendance-summary";
import SessionUsages from "./routes/nl3-package-schedules/schedule-buttons/session-usages";
import Nl3LiveclassGroupPackageSubscribers from "./routes/nl3-liveclass-group-package-subscribers";
import { CreateProjects } from "./routes/projects/create";
import { CreateVendorProjectUsers } from "./routes/vendor-project-users/create";
import  CoHost  from "./routes/nl3-package-schedules/schedule-buttons/co-host";
import { CoHostCreate } from "./routes/nl3-package-schedules/schedule-buttons/co-host/filter";
import Observer from "./routes/nl3-package-schedules/schedule-buttons/observer";
import { ObserverCreate } from "./routes/nl3-package-schedules/schedule-buttons/observer/filter";
import Nl3LiveclassMaster from "./routes/nl3-liveclass-masters";
import SessionInstances from "./routes/nl3-package-schedules/schedule-buttons/live-sessions/session-instances";

export const LiveClassesRoutes = [
  {
    exact: true,
    path: "/products",
    component: Products,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    exact: true,
    path: "/platforms",
    component: Platform,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    exact: true,
    path: "/projects",
    component: Projects,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/projects/create",
    component: CreateProjects,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/vendors",
    component: Vendors,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/vendor-accounts",
    component: VendorAccounts,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/vendor-users",
    component: VendorUsers,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/vendor-project-users",
    component: VendorProjectUsers,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/vendor-project-users/create",
    component: CreateVendorProjectUsers,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/employee-departments",
    component: EmployeeDepartments,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/employee-designations",
    component: EmployeeDesignations,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },
  {
    path: "/teachers",
    component: Teachers,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER],
  },

  {
    path: "/liveclass-packages",
    component: Nl3LiveclassPackages,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
  },
  {
    path: "/liveclass-packages/create",
    component: CreateNl3LiveclassPackage,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules",
    component: Nl3PackageSchedules,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/create",
    component: CreateNl3PackageSchedule,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/edit",
    component: EditNl3PackageSchedule,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/live-sessions",
    component: LiveSessions,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/live-sessions/session-instances",
    component: SessionInstances,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/attendance-summary",
    component: AttendanceSummary,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]
  },
  {
    path: "/package-schedules/allocated-sessions",
    component: AllocatedSession,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/session-usages",
    component: SessionUsages,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/co-host",
    component: CoHost,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/co-host/create",
    component: CoHostCreate,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/observer",
    component: Observer,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/package-schedules/observer/create",
    component: ObserverCreate,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER]

  },
  {
    path: "/liveclass-group-package-subscribers",
    component: Nl3LiveclassGroupPackageSubscribers,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER, NCMS_ROLES.LIVE_CLASSES_ADMIN]

  },
  {
    path: "/liveclass-masters",
    component: Nl3LiveclassMaster,
    user:[LIVE_CLASSES_ROLES.LIVE_CLASS_DEV_MANAGER, LIVE_CLASSES_ROLES.LIVE_CLASS_CONTENT_MANAGER, NCMS_ROLES.LIVE_CLASSES_ADMIN]

  }
];